import PropTypes from 'prop-types'

/**
 * @typedef {Object} DriverGroup
 * @property {string} driverGroupId - The id of the group.
 * @property {string} name - The name of the driver group.
 * @property {Array<string>} drivers - The list of driver ids in this group.
 * @property {Array<string>} controlFlags - list of control flags for the group
 */
export const driverGroupPropType = PropTypes.shape({
    driverGroupId: PropTypes.string,
    name: PropTypes.string,
    drivers: PropTypes.arrayOf(PropTypes.string),
    controlFlags: PropTypes.arrayOf(PropTypes.string)
})
